import * as R from "ramda";
import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Chip from "@material-ui/core/Chip";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import { Field } from "redux-form";
import { ReferenceField, FunctionField } from "react-admin";
import { FileInput } from "./RFComponents";
import {
  hasCPIPermission,
  hasClinicianPermission,
} from "../redux/user/selectors";
import PDIcon from "./pd.png";
import TheragunDeviceImg from "./theragun.png"
import PowerdotDeviceImg from "./powerdot.png"

export const ClinicalFullNameField = ({ record = {} }) => {
  if (!record) return null;
  return (
    <span style={{ width: "100%" }}>
      {" "}
      Clinician {record.first_name} {record.last_name}
    </span>
  );
};

ClinicalFullNameField.defaultProps = { label: "Clinician" };

export const InnerDoctorReferenceField = (props) => (
  <ReferenceField
    label="Clinician"
    source="doctor"
    {...props}
    reference="doctors"
    linkType={props.hasClinicianPermission}
    allowEmpty={true}
  >
    <ClinicalFullNameField />
  </ReferenceField>
);

const mapStateToPropsClinicianField = (state) => ({
  hasClinicianPermission: hasClinicianPermission(state),
});

const DoctorReferenceField_ = (props) => {
  return <InnerDoctorReferenceField {...props} />;
};

const enhanceDoctorField = compose(connect(mapStateToPropsClinicianField));

export const DoctorReferenceField = enhanceDoctorField(DoctorReferenceField_);

export const PatientFullNameField = ({ record = {} }) => {
  if (!record) return null;

  return (
    <span style={{ width: "100%" }}>
      {" "}
      Patient {record.first_name} {record.last_name}
    </span>
  );
};

export const ClinicNameField = ({ record = {} }) => {
  if (!record) return null;
  return <span style={{ width: "100%" }}> Clinic {record.name}</span>;
};

export const ClinicReferenceField = (props) => (
  <ReferenceField
    label="Clinic"
    source="id"
    {...props}
    reference="clinics"
    allowEmpty={true}
  >
    <ClinicNameField />
  </ReferenceField>
);

export const UserEmailField = ({ record = {} }) => {
  if (!record) return null;
  return <span style={{ width: "100%" }}> {record.email}</span>;
};

export const AvatarField = ({ record, size }) => {
  if (!record.thumbnail_url) return null;
  return (
    <Avatar
      src={`${record.thumbnail_url}?size=${size}x${size}`}
      size={size}
      style={{ width: size, height: size }}
    />
  );
};

AvatarField.defaultProps = {
  size: 25,
};

const PowerDotIcon = (size) => (
  <Tooltip title="Linked to PowerDot Consumer App" placement="top">
    <Avatar src={PDIcon} style={{ width: "20px", height: "20px" }} />
  </Tooltip>
);

export const DeviceFamilyField = ({record = {}, size}) => {
    if (!record) {
        return null;
    }
    let deviceImg = null;
    let deviceFamilyName = null;
    if (record.deviceFamily === 1) {
        deviceImg = PowerdotDeviceImg;
        deviceFamilyName = "Powerdot";
    }
    if (record.deviceFamily === 2) {
        deviceImg = TheragunDeviceImg;
        deviceFamilyName = "Theragun";
    }
    if (deviceImg === null) {
        return null;
    }
    return (
        <Tooltip title={`${deviceFamilyName} device family`} placement="top">
            <img alt={`${deviceFamilyName}`} src={deviceImg} style={{ width: "30px", height: "30px", borderRadius: "0%", objectFit: "scale-down" }} />
        </Tooltip>
    );
}


const FullNameField = ({ record = {}, size }) => {
  if (!record) {
    return null;
  }
  return (
    <div style={{ display: "flex", flexWrap: "nowrap", alignItems: "center" }}>
      <AvatarField record={record} size={size} />
      &nbsp;{record.first_name} {record.last_name}&nbsp;
      {record.remote_invite_status &&
        record.remote_invite_status !== "not_send" && <PowerDotIcon />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  hasCPIPermission: hasCPIPermission(state),
});

const enhancePatientField = compose(connect(mapStateToProps));

export const InnerPatientReferenceField = (props) => (
  <ReferenceField
    label="Patient"
    source="id"
    {...props}
    reference="patients"
    linkType={props.hasCPIPermission}
    allowEmpty={true}
  >
    <FullNameField />
  </ReferenceField>
);

const PatientReferenceField_ = (props) => {
  return <InnerPatientReferenceField {...props} />;
};

export const PatientReferenceField = enhancePatientField(
  PatientReferenceField_
);

const styles = {
  root: { display: "inline-block", marginTop: "1em", zIndex: 2 },
  content: { padding: 0, "&:last-child": { padding: 0 } },
  img: {
    width: "initial",
    minWidth: "initial",
    maxWidth: "42em",
    maxHeight: "15em",
  },
};

export const Poster = withStyles(styles)(({ classes, record }) => (
  <Card className={classes.root}>
    <CardContent className={classes.content}>
      <img src={record.thumbnail_url} alt="" className={classes.img} />
    </CardContent>
  </Card>
));

export class AvatarFileInput extends React.Component {
  render() {
    return (
      <span>
        <Field name="avatar" component={FileInput} />
        <label htmlFor="avatar-file-input">
          <Button variant="raised" component="span" size="small">
            Upload
          </Button>
        </label>
      </span>
    );
  }
}

const stylesW = {
  main: { display: "flex", flexWrap: "wrap" },
  chip: { margin: 4 },
};

const week = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

export const WeekdaysField = ({ record, translate }) => (
  <span style={stylesW.main}>
    {record.periodization &&
      record.periodization.map((day, index) => (
        <Chip key={index} style={stylesW.chip} label={`Every ${week[day]}`} />
      ))}
  </span>
);

export const TargetField = (props) => {
  const { record } = props;
  if (!record) return null;
  const { entity } = record;
  switch (entity) {
    case "Patient": {
      return (
        <>
          <span>Target Patient:</span>
          <ReferenceField
            label="Patient"
            source="db_id"
            reference="patients"
            {...props}
          >
            <FullNameField />
          </ReferenceField>
        </>
      );
    }

    case "SessionSummary": {
      let label, reference;
      const sessionType = R.pathOr(null, ["target", "type"], record);
      if (!sessionType) {
        return null;
      }
      if (record.target.type === "completed_session") {
        label = "Completed Session";
        reference = "completed_sessions";
      } else {
        label = "Running Session";
        reference = "running_sessions";
      }

      return (
        <>
          <span>Target Session:</span>
          <ReferenceField
            label={label}
            reference={reference}
            source="target.id"
            {...props}
          >
            <FunctionField render={(record) => `${label} #${record.id}`} />
          </ReferenceField>
        </>
      );
    }

    case "Attachment": {
      const url = R.pathOr(null, ["target", "meta", "url"], record);
      const thumbnailUrl = R.pathOr(
        null,
        ["target", "meta", "thumbnail"],
        record
      );
      const attachmentType = R.pathOr(null, ["target", "meta", "type"], record);

      if (!url) {
        return null;
      }

      return (
        <>
          <span>Target {attachmentType}: </span>
          <br />
          <a href={url} target="_blank">
            <img
              src={thumbnailUrl}
              style={{ width: "160px", height: "160px" }}
            />
          </a>
        </>
      );
    }

    case "ScheduleProgram": {
      return (
        <>
          <span>Target Schedule Session:</span>
          <ReferenceField
            reference="scheduled_sessions"
            source="target.id"
            {...props}
          >
            <FunctionField
              render={(record) => `Scheduled session #${record.id}`}
            />
          </ReferenceField>
        </>
      );
    }

    case "PatientNote": {
      return (
        <>
          <span>Target Patient: </span>
          <ReferenceField reference="patients" source="target.id" {...props}>
            <FullNameField />
          </ReferenceField>
        </>
      );
    }

    case "User": {
      return (
        <>
          <span>Target Clinician: </span>
          <br />
          <ReferenceField reference="doctors" source="target.id" {...props}>
            <ClinicalFullNameField />
          </ReferenceField>
        </>
      );
    }

    case "DoctorProfile": {
      return (
        <>
          <span>Target Clinician: </span>
          <br />
          <ReferenceField reference="doctors" source="target.id" {...props}>
            <ClinicalFullNameField />
          </ReferenceField>
        </>
      );
    }

    case "FullProgram": {
      const sessionType = R.pathOr(null, ["target", "type"], record);
      if (!sessionType) {
        return null;
      }
      let reference, label;
      if (record.target.type === "completed_session") {
        label = "Completed Session";
        reference = "completed_sessions";
      } else {
        label = "Runnig Session";
        reference = "running_sessions";
      }

      return (
        <>
          <span>Target Session:</span>
          <ReferenceField reference={reference} source="target.id" {...props}>
            <FunctionField render={(record) => `${label} #${record.id}`} />
          </ReferenceField>
        </>
      );
    }

    case "CustomizedSubphaseProgram": {
      const sessionType = R.pathOr(null, ["target", "type"], record);
      if (!sessionType) {
        return null;
      }
      let reference, label;
      if (record.target.type === "completed_session") {
        label = "Completed Session";
        reference = "completed_sessions";
      } else {
        label = "Runnig Session";
        reference = "running_sessions";
      }
      return (
        <>
          <span>Target Session:</span>
          <ReferenceField reference={reference} source="target.id" {...props}>
            <FunctionField render={(record) => `${label} #${record.id}`} />
          </ReferenceField>
        </>
      );
    }

    default: {
      return (
        <>
          <span>Target:</span>
          <div>
            <span>n/a</span>
          </div>
        </>
      );
    }
  }
};
